import React from 'react';
import PublicPageLayout from '../../components/layout/PublicPageLayout';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiBook, FiCheckSquare, FiAlertCircle } = FiIcons;

const LovverkPage = () => {
  return (
    <PublicPageLayout 
      title="Varsling i Arbeidsmiljøloven" 
      subtitle="Krav, rettigheter og plikter etter kapittel 2 A."
      activePage="/arbeidsmiljoloven-varsling"
    >
      <article className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 space-y-12">
        
        {/* Intro */}
        <section className="prose prose-lg prose-slate max-w-none">
          <p className="text-xl leading-relaxed text-slate-600 font-medium">
            Arbeidsmiljøloven kapittel 2 A gir arbeidstakere en lovfestet rett til å varsle om kritikkverdige forhold. Loven stiller samtidig strenge krav til hvordan arbeidsgiver skal legge til rette for varsling og håndtere innkomne saker.
          </p>
        </section>

        {/* Main Requirements Box */}
        <section className="bg-slate-900 text-white rounded-2xl p-8 shadow-lg">
          <h2 className="text-2xl font-bold mb-6 flex items-center gap-3">
            <SafeIcon icon={FiBook} className="text-blue-400" />
            § 2 A-6. Plikt til å utarbeide rutiner
          </h2>
          <div className="space-y-6 text-slate-300">
            <p>
              Arbeidsgiver skal i tilknytning til det systematiske helse-, miljø- og sikkerhetsarbeidet utarbeide rutiner for intern varsling. Rutinene skal utarbeides i samarbeid med arbeidstakerne og deres tillitsvalgte.
            </p>
            <div className="bg-white/10 p-4 rounded-xl border border-white/10">
              <h4 className="font-bold text-white mb-2">Rutinene skal inneholde:</h4>
              <ul className="list-disc pl-5 space-y-1">
                <li>Oppfordring til å varsle om kritikkverdige forhold</li>
                <li>Fremgangsmåte for varsling</li>
                <li>Fremgangsmåte for mottak, behandling og oppfølging</li>
              </ul>
            </div>
          </div>
        </section>

        {/* Detailed Sections - Mode 1 */}
        <section className="space-y-8 text-slate-600 leading-relaxed">
          <div>
            <h3 className="text-2xl font-bold text-slate-900 mb-3">Hvem gjelder reglene for?</h3>
            <p>
              Plikten til å ha skriftlige varslingsrutiner gjelder alle virksomheter med <strong>5 eller flere ansatte</strong>. Også mindre virksomheter bør ha slike rutiner dersom forholdene tilsier det.
            </p>
          </div>

          <div>
            <h3 className="text-2xl font-bold text-slate-900 mb-3">Aktivitetsplikten (§ 2 A-3)</h3>
            <p>
              Når det er varslet, skal arbeidsgiver sørge for at varselet blir undersøkt innen rimelig tid. Arbeidsgiver skal særlig påse at den som har varslet har et fullt forsvarlig arbeidsmiljø. Om nødvendig skal det sørges for tiltak som er egnet til å forebygge gjengjeldelse.
            </p>
          </div>
        </section>

        {/* Compliance Proof */}
        <section className="bg-green-50 border border-green-200 rounded-2xl p-8">
          <h3 className="text-xl font-bold text-green-900 mb-4 flex items-center gap-2">
            <SafeIcon icon={FiCheckSquare} />
            Hvordan HMSVarsling sikrer etterlevelse
          </h3>
          <p className="text-green-800 mb-6">
            Vår plattform er bygget spesifikt for å oppfylle kravene i arbeidsmiljøloven og EUs varslingsdirektiv. Ved å bruke systemet får dere:
          </p>
          <ul className="grid md:grid-cols-2 gap-4">
            {[
              "Ferdige forslag til varslingsrutiner",
              "Sikker, kryptert kanal for mottak",
              "System for frister og saksbehandling",
              "Dokumentasjonslogg for tilsyn",
              "Ivaretakelse av anonymitet",
              "Tilgangsstyring og personvern"
            ].map((item, i) => (
              <li key={i} className="flex items-center gap-2 text-green-800 font-medium">
                <SafeIcon icon={FiCheckSquare} className="text-green-600" /> {item}
              </li>
            ))}
          </ul>
        </section>

        {/* Alert */}
        <div className="flex items-start gap-4 p-6 bg-yellow-50 rounded-xl border border-yellow-100 text-yellow-900">
          <SafeIcon icon={FiAlertCircle} className="text-2xl text-yellow-600 mt-1" />
          <div>
            <h4 className="font-bold mb-1">Konsekvenser ved brudd</h4>
            <p className="text-sm opacity-90">
              Manglende varslingsrutiner kan føre til pålegg fra Arbeidstilsynet og bøter. Ved en eventuell rettssak om gjengjeldelse, vil manglende rutiner ofte føre til at bevisbyrden legges over på arbeidsgiver.
            </p>
          </div>
        </div>

      </article>
    </PublicPageLayout>
  );
};

export default LovverkPage;